const { localStorage, sessionStorage } = window;

const LocalStorage = {
  setItem(key: string, value: string): void {
    localStorage.setItem(key, JSON.stringify(value));
  },
  getItem(key: string): string | null {
    const value = localStorage.getItem(key) as string;

    try {
      return JSON.parse(value);
    } catch (e) {
      return null;
    }
  },
  remove(key: string): void {
    localStorage.removeItem(key);
  },

  clear(): void {
    localStorage.clear();
  },
};

const SessionStorage = {
  setItem(key: string, value: string): void {
    sessionStorage.setItem(key, JSON.stringify(value));
  },
  getItem(key: string): string | null {
    const value = sessionStorage.getItem(key) as string;

    try {
      return JSON.parse(value);
    } catch (e) {
      return null;
    }
  },
  remove(key: string): void {
    sessionStorage.removeItem(key);
  },

  clear(): void {
    sessionStorage.clear();
  },
};

export { LocalStorage, SessionStorage };
